"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=token.interface.js.map